// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__2A4NH","col":"CardReaderDesc_col__3HoSW","label":"CardReaderDesc_label__3GroB"};